import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {addUrlProps, UrlQueryParamTypes, UrlUpdateTypes} from 'react-url-query';
import cx from 'classnames';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';
import Paper from '@material-ui/core/Paper';
import CollectionCaseEditor from 'components/page/CollectionCaseEditor';
import {getCollectionCasePage} from 'api/debtCollectionMonitor';
import {toBool} from 'data/converter';
import {modalHide, modalShow, modalHideAll} from 'actions/modal';
import styles from './CollectionCaseScroll.module.sass';
import CollectionCaseTable from 'components/page/CollectionCase/CollectionCaseTable';
import InfiniteScroller from 'react-infinite-scroller';
import Spinner from 'components/common/Spinner';
import CollectionCaseHeader from './CollectionCaseHeader';
import {getCorrect} from 'data/converter';

const mapStateToProps = state => ({
  dicts: state.dictionary
});

const urlPropsQueryConfig = {
  count: {type: UrlQueryParamTypes.number},
  filter: {type: UrlQueryParamTypes.json},
  showFilter: {type: UrlQueryParamTypes.string},
  sort: {type: UrlQueryParamTypes.json},
  openEditor: {type: UrlQueryParamTypes.number, updateType: UrlUpdateTypes.pushIn},
};

@connect(mapStateToProps)
@addUrlProps({urlPropsQueryConfig})
class CollectionCase extends PureComponent {
  static defaultProps = {
    count: 50
  };

  static propTypes = {
    count: PropTypes.number,
    filter: PropTypes.object,
    sort: PropTypes.object,
    openEditor: PropTypes.number,
    showFilter: PropTypes.string,

    onChangeCount: PropTypes.func,
    onChangeFilter: PropTypes.func,
    onChangeSort: PropTypes.func,
    onChangeOpenEditor: PropTypes.func,
    onChangeShowFilter: PropTypes.func,
  };

  state = {
    page: 1,
    total: -1,
    items: [],
    hasMore: false,
  };

  loadPageDebounce = debounce((args) => this.loadPage(args), 500);
  loadPageOldArgs = '';
  loadPage = ({page, count, sort, filter} = {}) => {
    if (sort) sort.desc = toBool(sort.desc);

    //если предидущий ывзов был с теми же аргументами то ничего не делать
    const loadPageArgs = JSON.stringify({page, count, sort, filter});
    if (loadPageArgs === this.loadPageOldArgs) return;
    this.loadPageOldArgs = loadPageArgs;

    //отменить дозагрузку элементов
    this.loadFuncCancel = true;
    getCollectionCasePage({page, count, sort, filter})
      .then(data => {
        this.setState({items: data.items, total: data.total, hasMore: data.items.length < data.total, page: 1});
      });
  };

  loadFuncCancel = false;
  loadFunc = () => {
    let {page} = this.state;
    page = page + 1;

    const {count, sort, filter} = this.props;
    if (sort) sort.desc = toBool(sort.desc);

    const {items} = this.state;

    const loadPageArgs = JSON.stringify({page, count, sort, filter});
    if (loadPageArgs === this.loadPageOldArgs) return;
    this.loadPageOldArgs = loadPageArgs;

    this.loadFuncCancel = false;
    getCollectionCasePage({page, count, sort, filter})
      .then(data => {
        let allItems = items.concat(data.items);
        //отменить дозагрузку элементов если за время выполнения запроса это стало не актуально
        if (this.loadFuncCancel) return;
        this.setState({items: allItems, total: data.total, hasMore: allItems.length < data.total, page});
      });
  };

  checkPropsOpenEditor = (nextProps, oldProps = {}) => {
    const {dispatch, onChangeOpenEditor, filter} = this.props;

    const {openEditor} = nextProps;
    const {openEditor: oldOpenEditor} = oldProps;

    const th = this;

    const showEditor = () => {
      return dispatch(modalShow(
        <CollectionCaseEditor
          onCancel={() => {
            dispatch(modalHide());
            onChangeOpenEditor(null);
          }}
          onSave={() => {
            dispatch(modalHide());
            const getCollectionCasePageArgs = {count: 1, filter: {...filter, id: openEditor}};
            getCollectionCasePage(getCollectionCasePageArgs)
              .then((data = {}) => {
                const {items: dataItems = []} = data;
                const row = dataItems[0];
                const oldItems = th.state.items;
                const newItems = oldItems.map((a) => a.id === openEditor ? row : a).filter(a => !!a);
                onChangeOpenEditor(null);
                this.setState({items: newItems});
              });
          }}
          id={openEditor.toString()}/>,
        {
          fullScreen: true,
          onClose: () => onChangeOpenEditor(null)
        }));
    };

    if (!(openEditor === 0 || openEditor) && (oldOpenEditor === 0 || oldOpenEditor)) {
      dispatch(modalHideAll());
    }
    else if ((openEditor === 0 || openEditor) && !(oldOpenEditor === 0 || oldOpenEditor))
      showEditor();
    else if (openEditor !== oldOpenEditor && (openEditor === 0 || openEditor))
      dispatch(modalHideAll()).then(() => showEditor());
  };

  checkPropsPage = (nextProps, currentProps = {}) => {
    const getPageProps = (props) => ({ count: props.count, sort: props.sort, filter: props.filter});
    const getFilterAndSort = (props) => ({ sort: props.sort, filter: props.filter });

    const newPageProps = getPageProps(nextProps);
    const oldPageProps = getPageProps(currentProps);

    //если поменялся фильтр или сортировка то проскролить вверх
    if (JSON.stringify(getFilterAndSort(nextProps)) !== JSON.stringify(getFilterAndSort(currentProps))) {
      const scrollContainer = this.scrollContainer;
      if (scrollContainer) {
        if (scrollContainer.scrollTo) {
          scrollContainer.scrollTo(scrollContainer.scrollLeft,0);
        } else {
          scrollContainer.scrollTop = 0;
        }
      }
    }

    if (JSON.stringify(newPageProps) !== JSON.stringify(oldPageProps)) {
      this.loadPageDebounce(newPageProps);
    }
  };

  checkProps = (nextProps, oldProps = {}) => {
    this.checkPropsOpenEditor(nextProps, oldProps);
    this.checkPropsPage(nextProps, oldProps);
  };

  componentDidMount() {
    this.checkProps(this.props, {});
  }

  componentWillReceiveProps(nextProps) {
    this.checkProps(nextProps, this.props);
  }

  handleFilterButtonOnClick = () => {
    const {filter, showFilter} = this.props;
    let {sort} = this.props;
    if (sort) sort.desc = toBool(sort.desc);

    const newFilter = showFilter ? null : filter;
    this.props.onChangeFilter(newFilter);
    this.props.onChangeShowFilter(showFilter ? null : 'true');
    this.props.onChangeSort(sort);
  };

  handleOnChangePage = ({page, count, sort, filter}) => {
    const {onChangePage, onChangeCount, onChangeFilter, onChangeSort, onChangeShowFilter} = this.props;

    if (page !== undefined) onChangePage(page);
    if (count !== undefined) onChangeCount(count);
    if (filter !== undefined) {
      onChangeFilter(filter);
      if (!!filter) onChangeShowFilter(true);
      else onChangeShowFilter(null);
    }

    if (sort) onChangeSort(sort);
  };

  scrollContainer;

  render() {
    const {hasMore, total, items} = this.state;
    let {showFilter, filter, sort} = this.props;

    return (
      <div className={styles.box}>
        <Paper className={styles.paper}>
          <CollectionCaseHeader className={styles.header} value={{sort, filter}} visibleFilter={showFilter} onChange={(v) => this.handleOnChangePage(v)}/>
          <div key={'table-scroll-container'} ref={(r) => this.scrollContainer = r} className={cx(styles.tableBox, 'otc-date-close-if-scroll-this')}>
            <InfiniteScroller
              initialLoad={false}
              pageStart={0}
              loadMore={this.loadFunc}
              hasMore={hasMore}
              loader={<Spinner className="loader" key={0} />}
              useWindow={false}
            >
              <CollectionCaseTable
                items={items}
                filter={filter}
                showFilter={showFilter}
                sort={sort}
                onClickRow={(a) => this.props.onChangeOpenEditor(a)}
                onChangeFilter={(a) => {
                  this.props.onChangeFilter(a);
                }}
                onChangeSort={(a) => this.props.onChangeSort(a)}
              />
            </InfiniteScroller>
          </div>
          {total && total > 0 &&
          <div className={styles.bottom}>
            <div className={styles.total}>всего {total} {getCorrect(total, 'запись', 'записи', 'записей')}</div>
          </div>
          }
        </Paper>
      </div>
    );
  }
}

export default CollectionCase;


// WEBPACK FOOTER //
// ./src/components/page/CollectionCase/CollectionCaseScroll.jsx